






import Vue from "vue"
export default Vue.extend({
  props: {
    hasMarginBottom: {
      type: Boolean,
      default: false,
    },
  },
})
